import React from 'react';

import { Tooltip } from '@mui/material';

import API from 'app/API';
import useCopyToClipboard from 'pages/hooks/use-copy-to-clipboard';

import DownloadIcon from './assets/download.svg';
import ReportIcon from './assets/report.svg';
import ShareIcon from './assets/share.svg';
import ToolbarItem from './components/ToolbarItem';
import useStyles from './styles';

interface Props {
    id: string;
    viewsCount: number | undefined;
    className?: string;
}

const Toolbar: React.FC<Props> = ({ id, viewsCount, className }) => {
    const { classes, cx } = useStyles();
    const [copy, isCopied] = useCopyToClipboard();

    return (
        <div className={cx(classes.root, className)}>
            <Tooltip title={'Link copied!'} open={isCopied}>
                <ToolbarItem icon={ShareIcon} label={viewsCount ?? 0} onClick={() => copy(window.location.href)} />
            </Tooltip>
            <ToolbarItem
                icon={DownloadIcon}
                label={'.json'}
                onClick={() => window.open(`${API.SEARCH_ID.url}?id=${id}`)}
            />
            <ToolbarItem icon={ReportIcon} label={'Report'} hidden />
        </div>
    );
};

export default Toolbar;
